export enum mobViewPanelAssetConfig {
    mobPanelButtons = "assets/mobViewPanel/landscapesetting_1.json",
    mobPanelButtonsImage = "assets/mobViewPanel/landscapesetting_1.png",


}